// src/App.tsx
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';

import WorkItems from './pages/WorkItems';
import Header from './components/Header';
import NextItems from './pages/NextItems';
import { LoginProvider, LoginRequred } from './auth';
import { Home } from './pages/Home';
import { FormDemo } from './pages/FormDemo';
import 'unfonts.css';

import * as Sentry from '@sentry/react';
import React from 'react';

Sentry.init({
  dsn: 'https://95fb89bad9768a67a66c00821f5d9702@o4505749244674048.ingest.sentry.io/4506079804325888',
  integrations: [
    new Sentry.BrowserTracing({
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      ),
    }),
    new Sentry.Replay(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const queryClient = new QueryClient();
queryClient.setDefaultOptions({
  queries: {
    refetchOnWindowFocus: false,
    refetchInterval: false,
  },
});

// Microsoft MSAL configuration
const msalConfig = {
  auth: {
    clientId: 'af688efa-206f-4951-8207-ce2d9ee2f91c',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <GoogleOAuthProvider clientId="951064276788-1elnrg33bm4krp65l51av21k83bno61r.apps.googleusercontent.com">
        <MsalProvider instance={msalInstance}>
          <LoginProvider>
            <div style={{ backgroundColor: 'var(--grayscale-50)' }}>
              <Router>
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route
                    path="/queue"
                    element={
                      <LoginRequred>
                        <NextItems />
                      </LoginRequred>
                    }
                  />
                  <Route
                    path="/items"
                    element={
                      <LoginRequred>
                        <WorkItems />
                      </LoginRequred>
                    }
                  />
                  <Route path="/form-demo/:type" element={<FormDemo />} />
                </Routes>
              </Router>
            </div>
          </LoginProvider>
        </MsalProvider>
      </GoogleOAuthProvider>
    </QueryClientProvider>
  );
}

export default App;
